<template>
    <vProductPeriodListComponent :postList="postList" v-if="flag"></vProductPeriodListComponent>
</template>
<script>
import vProductPeriodListComponent from '../../listComponent/basicdata/product/productPeriodComponent.vue';
export default {
    name: 'productPeriodList',
    components: {
        vProductPeriodListComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                updateBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                product_rid: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>